export enum StatusVp5 {
  ACTIVE = 'global.bdp-status.active',
  NOT_ACTIVE = 'global.bdp-status.not-active',
}

export enum StatusAdminVp5 {
  IN_USE = 'global.vp5-status.in-use',
  NOT_IN_USE = 'global.vp5-status.not-in-use',
  IMAGE_NOT_COMPATIBLE = 'global.vp5-status.image-not-compatible',
  IN_PROMOTION = 'global.vp5-status.in-promotion'
}
